import React from 'react';
import { ReactComponent as EmailIcon } from '../../../src/assets/images/icons/email.svg';
import { useTheme } from '@mui/material';

const GradientEmailIcon = () => {
	const theme = useTheme();
	const style = {
		mainColor: theme.palette.primary.main,
		secondaryColor: theme.palette.secondary.main
	};
	return (
		<svg
			width="145"
			height="145"
			viewBox="0 0 145 145"
			xmlns="http://www.w3.org/2000/svg"
			preserveAspectRatio="xMidYMid meet"
		>
			<defs>
				<linearGradient id="grad1" x1="0%" y1="0%" x2="90%" y2="0%">
					<stop offset="0%" stopColor={style.mainColor} />
					<stop offset="90%" stopColor={style.secondaryColor} />
				</linearGradient>
			</defs>
			<EmailIcon className="email-step-icon-style" fill="url(#grad1)" />
		</svg>
	);
};

export default GradientEmailIcon;
